

















































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Types
import { IFile } from "@/models/files";
import { IImportSourceError } from "@/models/imports";

@Component({
  components: {
    "import-files-provider": () =>
      import("@/components/app/admin/imports/importFilesProvider.vue"),
    "import-files-listing": () =>
      import("@/components/app/admin/imports/importFilesListing.vue")
  }
})
export default class SelectImportFilesListing extends Vue {
  // Props

  @Prop({ default: () => [] })
  public selectedFileIds!: IFile["id"];

  @Prop({ default: () => [] })
  public sourceFilesErrors!: IImportSourceError[];

  // Computed

  public get activeSourceFilesErrors() {
    return _.filter(this.sourceFilesErrors, ["isActive", true]);
  }
}
